/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:29:29
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 11:40:16
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/DropDown/Trigger.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';

const Trigger = (props) => {
  const { id, name, className, hideArrow, onClick } = props;
  return (
    <div
      onClick={onClick}
      className={`${css.nameContainer} ${className || ''}`}
      {...(id ? { id } : {})}>
      {name} {!hideArrow && <Icon type='icondown' className={css.icon} />}
    </div>
  );
};

export default Trigger;
